import { createContext } from 'react';
import { AuthUser } from './types';
import { Organization } from '../../types/shared';

interface AuthContextType {
  user: AuthUser | null;
  organization: Organization | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (user: AuthUser, accessToken: string, refreshToken: string) => void;
  logout: () => void;
  refreshOrganization: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
